import { BinaryFileResult } from "@/types/generated/UsedGeneratedTypes";

export class Dataset {
  id: string;
  periode: string | undefined;
  published: boolean = false;
  publishDate: string | Date | undefined;
  publishUser: { email: string } | undefined;
  lastUploadDate: string | Date | undefined;
  datasets: BinaryFileResult[] = [];

  constructor(file: BinaryFileResult) {
    this.id = file.id;
    this.lastUploadDate = file.params.createdate;
    this.published = file.params.published;
    this.publishDate = file.params.publisheddate;
    this.publishUser = file.params.publisheduser;
    this.periode = this.periodeToString(
      file.params.binaryFileDataset.from,
      file.params.binaryFileDataset.to,
    );
  }

  addDataset(dataset: BinaryFileResult): void {
    this.published = dataset.params.published ? dataset.params.published : this.published;
    this.publishDate = dataset.params.published
      ? dataset.params.publisheddate
      : this.publishDate;
    this.publishUser = dataset.params.published
      ? dataset.params.publisheduser
      : this.publishUser;

    this.lastUploadDate
      = dataset.params.createdate > this.lastUploadDate!
        ? dataset.params.createdate
        : this.lastUploadDate;

    this.datasets.push(dataset);
  }

  dateToString(dateString: string | Date): string {
    const date = new Date(dateString);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    const HH = String(date.getHours()).padStart(2, "0");
    const MM = String(date.getMinutes()).padStart(2, "0");

    return `${dd}/${mm}/${yyyy} ${HH}:${MM}`;
  }

  periodeToString(from: string | Date, to: string | Date): string | undefined {
    if (from && to) {
      return "du " + this.dateToString(from) + " au " + this.dateToString(to);
    }
    return undefined;
  }

  get publication(): string {
    if (this.published && this.publishDate && this.publishUser) {
      return `publié le ${this.dateToString(this.publishDate)} par ${this.publishUser.email}`;
    }
    else {
      return "";
    }
  }
}
